export const GET_ITEM_BY_ID_GETTER = 'getByid'
export const GET_ITEM_INDEX_GETTER = 'getIndex'
